import { useEffect } from 'react';
import { useSessionsStore } from './useSessionStore';

export const useSessionsData = () => {
  const {
    sessions,
    pageInfo,
    totalCount,
    pendingCount,
    confirmedCount,
    dismissedCount,
    loading,
    error,
    fetchSessionsWithCount,
    currentStatus,
  } = useSessionsStore();

  // Fetch both sessions and counts on mount and when status changes
  useEffect(() => {
    fetchSessionsWithCount();
  }, [fetchSessionsWithCount, currentStatus]);

  return {
    sessions,
    pageInfo,
    totalCount,
    pendingCount,
    confirmedCount,
    dismissedCount,
    loading,
    error,
    refetch: fetchSessionsWithCount,
  };
};
